import { observer } from "mobx-react-lite";
import * as React from "react";
import { Link } from "react-router-dom";
import { classNames } from "src/common/classNames";
import { PropsTableRow } from "src/components/ReactiveTable/components/ReactiveTable/componentProps";
import {
  AbstractFilters,
  AbstractRow,
} from "src/components/ReactiveTable/RtTypes";

import * as stylesCommon from "./common.module.less";
import { getCellClassName } from "./getCellClassName";
import { getCellStyle } from "./getCellStyle";
import * as styles from "./TableRow.module.less";
/**
 * Компонент строки таблицы
 */
export const TableRow = observer(
  <TRow extends AbstractRow, TFilters extends AbstractFilters>(
    props: PropsTableRow<TRow, TFilters>,
  ) => {
    const {
      row,
      store,
      columns,
      isSelected,
      components,
      fixedColumnsMap,
      clickProps,
    } = props;
    const { SelectionCell, Cell } = components;

    const rowKey = store.getRowKey(row);
    const hasSelection = Boolean(store.selectionType);
    const isRowDisabled = store.rowSelectionDisabled?.(row) ?? false;

    const buildContent = () => (
      <>
        {/* Колонка для selection (если включен) */}
        {hasSelection && (
          <SelectionCell
            row={row}
            rowKey={rowKey}
            store={store}
            isSelected={isSelected}
            disabled={isRowDisabled}
          />
        )}

        {/* Ячейки данных */}
        {columns.map((column) => {
          const fixedInfo = fixedColumnsMap?.get(column.key);
          return (
            <Cell
              key={column.key}
              row={row}
              column={column}
              className={getCellClassName(fixedInfo)}
              style={getCellStyle(column, store, fixedInfo)}
            />
          );
        })}
      </>
    );

    const buildRow = () => {
      const rowClassName = classNames([
        stylesCommon.commonRow,
        styles.tableRow,
        isSelected && styles.selected,
        isRowDisabled && styles.disabled,
      ]);
      if (clickProps?.type === "link") {
        return (
          <Link to={clickProps.builder(row)} className={rowClassName}>
            {buildContent()}
          </Link>
        );
      }
      if (clickProps?.type === "click") {
        return (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          <div className={rowClassName} onClick={() => clickProps.handler(row)}>
            {buildContent()}
          </div>
        );
      }
      return <div className={rowClassName}>{buildContent()}</div>;
    };

    return buildRow();
  },
);
